import { Component, OnInit } from '@angular/core';
import { StepCard } from '../check-pets-chip/check-pets-chip.component';
import { CheckChip, UsefulLinks } from '../../constants/check-chip.constants';

@Component({
  selector: 'app-purina-check-chip',
  templateUrl: './purina-check-chip.component.html',
  styleUrls: ['./purina-check-chip.component.scss'],
})
export class PurinaCheckChipComponent implements OnInit {
  public nextStepCards: Array<StepCard> = [];
  public usefulLinkCards: Array<StepCard> = [];

  constructor() {}

  ngOnInit(): void {
    this.nextStepCards = CheckChip;
    this.usefulLinkCards = UsefulLinks;
  }
}
